var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAccountExpired(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 3,
    height: 10,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#account_expired_svg__clip0_22_2855)",
    fill: "#F74F4F",
    stroke: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.5 10v.5h3v-3h-3V10zM.5 7v.5h3v-7h-3V7z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "account_expired_svg__clip0_22_2855"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h3v10H0z"
  })))));
}
export default __webpack_public_path__ + "static/account_expired.9bed838d.svg";
export { SvgAccountExpired as ReactComponent };